import React from "react";

const ErrorMessage = ({ message }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center text-red-500">
      Error: {message}
    </div>
  );
};

export default ErrorMessage;
